import React from "react";
import { Layout, Typography } from "antd";

const { Content } = Layout;
const { Title } = Typography;

const Application: React.FC = () => {
  return (
    <Content style={{ padding: "50px", textAlign: "center" }}>
      <Title level={1}>Application Page</Title>
      <p>This page will be implemented later with the application form.</p>
    </Content>
  );
};

export default Application;
